// The Inbox: every decision a person needs to make, gathered from Risk,
// Reconciliation, Dash gifts, Feedback, Profit and the VTpass wallet, ranked
// so the most urgent is first. Items disappear by themselves once they're
// dealt with on their own page.

export type InboxSeverity = 'critical' | 'high' | 'medium' | 'low';

export const SEVERITY_RANK: Record<InboxSeverity, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  low: 3,
};

export type InboxKind = 'system' | 'risk' | 'purchase' | 'gift' | 'transfer' | 'feedback' | 'costs';

export interface InboxItem {
  id: string;
  kind: InboxKind;
  severity: InboxSeverity;
  // What happened, in a few words.
  title: string;
  // Why it matters / what to do, in one sentence.
  why: string;
  // Short facts shown under the title (customer, amount, code…).
  meta: string[];
  // When the problem started, for "2h ago" and tie-breaks.
  since: string | null;
  action: { label: string; to: string };
  // The customer's chat id, for "Open customer".
  chatId?: string | null;
}

export type CheckState = 'ok' | 'warn' | 'down' | 'unknown';

// One line of the system status popover.
export interface SystemCheck {
  key: string;
  label: string;
  state: CheckState;
  detail: string;
}

export const KIND_LABELS: Record<InboxKind, string> = {
  system: 'System',
  risk: 'Risk',
  purchase: 'Purchase',
  gift: 'Dash gift',
  transfer: 'Bank transfer',
  feedback: 'Feedback',
  costs: 'Costs',
};
